import { CSSObject } from '@chakra-ui/react';
import featBg from '@/assets/gigabet/images/feature/featRaceBg.png';
import featBgMb from '@/assets/gigabet/images/feature/featRaceBgMb.png';
import { FeaturedRaceSchema } from '@/views/Home/races/components/Featured/styles/Featured.styles';

export const featuredRaceStyles: FeaturedRaceSchema = {
  buttonOddsProps: {
    variant: 'odds',
    fontFamily: 'accent',
    fontSize: 'sm',
    h: '8',
    w: '46px',
    borderRadius: 'md',
    lineHeight: 'normal',
  },
  svgMoreRacesArrowProps: {
    color: 'white',
    boxSize: '5',
  },
};
export const BoxCard: CSSObject = {
  px: '2',
  contain: 'unset',
};
export const FlexFeatureWrapper: CSSObject = {
  _after: {
    content: `''`,
    bgImage: [`url(${featBgMb})`, `url(${featBg})`],
    bgRepeat: 'no-repeat',
    bgSize: 'cover',
    bgPos: ['top', null, '20% 30%'],
    pos: 'absolute',
    h: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    zIndex: '-1',
    borderRadius: ['base', null, 'lg'],
    boxShadow: [
      'unset',
      null,
      '0px 4px 6px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 3px #20273F inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.2) inset',
    ],
    m: ['1', null, '0'],
  },
  boxShadow: [
    '0px 4px 6px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 3px #20273F inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.2) inset',
    null,
    'unset',
  ],
  bg: 'rgba(78, 178, 255, 0.14)',
  flex: '2',
  pos: 'relative',
  flexDir: 'column',
  borderRadius: 'md',
  border: '2px solid',
  borderColor: 'alpha.400',
  minH: '250px',
  py: '4',
  px: '3',
};
export const FlexFeatureTitleWrapper: CSSObject = {
  flexDir: 'row',
  bgPos: 'center',
  justifyContent: 'space-between',
  alignItems: 'center',
  pt: '0',
  pos: 'relative',
  flex: '1.5',
  textShadow: '0px 4px 6px rgba(0, 0, 0, 0.20)',
  mt: '-2',
  mb: ['0', null, '2'],
  color: 'white',
  fontStyle: 'accent',
};
export const TextFeatureHeading: CSSObject = {
  display: 'none',
};
export const TextFeatureSubHeading: CSSObject = {
  display: 'none',
};
export const FlexGridRunnerItem: CSSObject = {
  borderBottom: '0',
};
export const GridCardContent: CSSObject = {
  gap: '2',
  gridTemplateColumns: 'auto',
  gridTemplateAreas: [`"."`, null, null, `". . ."`],
};
export const TextRunner: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
};
export const TextRunnerNumber: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'normal',
  _last: {
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'normal',
    pos: 'relative',
    top: '-2px',
  },
};
export const HeadingSlogan: CSSObject = {
  color: 'alpha.400',
  fontFamily: 'accent',
  fontSize: '3xl',
  textTransform: 'capitalize',
};
export const LinkRaceDetails: CSSObject = {
  display: 'none',
};
export const LinkCardHeader: CSSObject = {
  justifyContent: ['center', 'start'],
  gap: '2',
  px: 0,
  pt: [0, 'unset'],
  svg: {
    color: 'alpha.400',
    boxSize: '22px',
    filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
  },
};
export const TextCardHeader: CSSObject = {
  fontSize: 'sm',
  color: 'white',
  fontFamily: 'accent',
  fontWeight: 'normal',
  textTransform: 'capitalize',
  pt: '1',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.3)',
};
export const FlexFeatureCardWrapper: CSSObject = {
  alignItems: 'center',
};
export const TextRaceNumber: CSSObject = {
  fontFamily: 'roboto',
  bg: 'beta.800',
  borderRadius: 'sm',
  color: 'alpha.400',
  px: '1',
  h: '16px',
  maxH: '16px',
  minH: '16px',
  lineHeight: '16px',
};
export const FlexButtonsWrap: CSSObject = {
  justifyContent: 'space-between',
  w: '100%',
  minH: '50px',
  bg: `rgba(78, 178, 255, 0.14)`,
  borderRadius: 'lg',
  boxShadow:
    '0px 4px 6px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 3px #20273F inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.2) inset',
  border: '2px solid',
  borderColor: 'alpha.400',
};
export const LinkFeatureCard: CSSObject = {
  color: 'white',
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'black',
  _hover: {
    textDecor: 'underline',
  },
};
export const TextScratched: CSSObject = {
  fontSize: '2xs',
  color: 'white',
  textTransform: 'uppercase',
};
